const AccessDeniedBehavior = {
    hide: 1,
    displayError :2,
    redirect: 3
};

export default AccessDeniedBehavior;